import { type FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { type Author_author$data } from './__generated__/Author_author.graphql.ts';
import Logo2020 from 'dibs-icons/exports/legacy/Logo2020.ts';
import styles from './author.scss';

type Props = {
    author: Author_author$data | null | undefined;
    formattedCreatedDate: string | null;
};

const AuthorComponent: FunctionComponent<Props> = ({ author, formattedCreatedDate }) => {
    const sellerPreferences = author?.sellerPreferences;
    if (sellerPreferences) {
        const { label: name, scrollLogo: logo, urlLabel } = sellerPreferences;
        if (name) {
            const url = `/dealers/${urlLabel}/`;
            return (
                <div className={styles.author}>
                    {logo && <img className={styles.authorLogo} src={logo} alt={name} />}
                    <div className={styles.authorInfo}>
                        <Link href={url}>
                            <span data-tn="seller-name">{name}</span>
                        </Link>
                        {formattedCreatedDate && (
                            <span data-tn="answer-date">{formattedCreatedDate}</span>
                        )}
                    </div>
                </div>
            );
        }
    }

    return (
        <div className={styles.author}>
            <Logo2020 className={styles.expertLogo} />
            <div className={styles.authorInfo}>
                <FormattedMessage
                    id="questionsAnswers.author.defaultAuthor"
                    defaultMessage="1stDibs Expert"
                />
                {formattedCreatedDate && <span>{formattedCreatedDate}</span>}
            </div>
        </div>
    );
};

export const Author = createFragmentContainer(AuthorComponent, {
    author: graphql`
        fragment Author_author on Seller {
            sellerPreferences {
                label
                urlLabel
                scrollLogo
            }
        }
    `,
});
